import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&文章部分
 *
 */


/**
 * 文章查询：列表
 * @param {*} query
 */
export const articleList = (query) => {
  return request({
    url: `${prefix}/article/list`,
    method: 'get',
    params: query
  })
}

/**
 * 文章查询
 * @param {*} query
 */
export const articleOne = (query) => {
  return request({
    url: `${prefix}/article`,
    method: 'get',
    params: query
  })
}

/**
 * 文章创建
 * @param {*} query
 */
export const articleCreate = (query) => {
  return request({
    url: `${prefix}/article`,
    method: 'post',
    data: query
  })
}

/**
 * 文章修改
 * @param {*} query
 */
export const articleUpdate = (query) => {
  return request({
    url: `${prefix}/article`,
    method: 'put',
    data: query
  })
}

/**
 * 文章修改状态
 * @param {*} query
 */
export const articleUpdateStatus = (query) => {
  return request({
    url: `${prefix}/article/status`,
    method: 'put',
    data: query
  })
}

/**
 * 文章删除
 * @param {*} query
 */
export const articleDestroy = (query) => {
  return request({
    url: `${prefix}/article`,
    method: 'delete',
    data: query
  })
}

/**
 * 文章删除 真
 * @param {*} query
 */
export const articleRemove = (query) => {
  return request({
    url: `${prefix}/article/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 文章恢复
 * @param {*} query
 */
export const articleRestore = (query) => {
  return request({
    url: `${prefix}/article/restore`,
    method: 'post',
    data: query
  })
}

/**
 * 文章克隆
 * @param {*} query
 */
export const articleClone = (query) => {
  return request({
    url: `${prefix}/article/clone`,
    method: 'post',
    data: query
  })
}

/**
 * 文章分类查询：列表
 * @param {*} query
 */
export const articleCategoryList = (query) => {
  return request({
    url: `${prefix}/article/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 文章分类查询
 * @param {*} query
 */
export const articleCategoryOne = (query) => {
  return request({
    url: `${prefix}/article/category`,
    method: 'get',
    params: query
  })
}

/**
 * 文章分类创建
 * @param {*} query
 */
export const articleCategoryCreate = (query) => {
  return request({
    url: `${prefix}/article/category`,
    method: 'post',
    data: query
  })
}

/**
 * 文章分类修改
 * @param {*} query
 */
export const articleCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/article/category`,
    method: 'put',
    data: query
  })
}

/**
 * 文章分类删除
 * @param {*} query
 */
export const articleCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/article/category`,
    method: 'delete',
    data: query
  })
}


// 审核 
export const auditStatus = (query) => {
  return request({
    url: `${prefix}/article/auditStatus`,
    method: 'put',
    data: query
  })
}
